import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { instructorSearchConnector } from '../../server/connector/InstructorSearchConnector'
import { updateExploreProfiles } from '../../redux/reducers/searchSlice'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import HeaderAppExplore from '../../sections/header/HeaderAppExplore'
import AppFooter from '../../sections/footer/AppFooter'
import { userStateData } from '../../data/userStateData'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { UserPost } from '../../types/posts'
import AppUserPost from '../../components/app_userPost/AppUserPost'

import './style.scss';
import { CommunitiesResultProfile } from '../../server/types'
import AppPostButton from '../../components/app_postButton/AppPostButton'
import AppPost from '../../components/app_post/AppPost'

function AppExplore() {
	const showNewPost = useAppSelector((state) => state.user.showNewPost)
	const communityProfiles: CommunitiesResultProfile[] = [
		{
			id: '1',
			name: 'Community Name',
			profile_pic: '/imgs/temp/community/temp-icon.png'
		},{
			id: '2',
			name: 'Skiing Community',
			profile_pic: '/imgs/temp/community/temp-comm_01.jpg'
		},{
			id: '3',
			name: 'Other Com',
			profile_pic: '/imgs/temp/community/temp-comm_02.png'
		},{
			id: '4',
			name: 'Example',
			profile_pic: '/imgs/temp/community/temp-comm_03.jpg'
		},{
			id: '1',
			name: 'Additional',
			profile_pic: '/imgs/temp/community/temp-icon.png'
		},{
			id: '2',
			name: 'New',
			profile_pic: '/imgs/temp/community/temp-comm_01.jpg'
		}
	]
	const [firstSearchLoaded, setFirstSearchLoaded] = useState<boolean>(false)

	const [userPosts, setUserPosts] = useState<UserPost[]>([])
	const [showingExplore, setShowingExplore] = useState<boolean>(true)

	const dispatch = useAppDispatch()

	useEffect(() => {
		// Assumes the log in check is done in the root App component before any page components are added to the dom
		if (userStateData.loggedIn) {
			makeInitialSearchRequest()
			getProfileData()
		} else {
			window.location.replace(`${PAGE_URLS.APP_ENTRY}`)
		}
	}, [])

	const makeInitialSearchRequest = () => {
		instructorSearchConnector.performExploreSearchRequest().then((successRequest) => {
			setFirstSearchLoaded(true)
			dispatch(updateExploreProfiles())
			if (!successRequest) {
				console.log('WARNING - [AppExplore] - makeInitialSearchRequest() failed')
			}
		})
	}

	const getProfileData = () => {
		// Fake post
		const fakePost: UserPost = {
			postId: '6666',
			sourceName: 'Test User',
			community: 'Community Name',
			sourceImgSrc: 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg', // userStateData.getUserIconUrl() || '',
			postDate: 0,
			postMsg: 'This is an example fake post used for testing the front end layout',
			postImgSrc: undefined,
			verified: true
		}
		const fakePost2: UserPost = {
			postId: '66626',
			sourceName: 'Test User',
			community: 'Community Name',
			sourceImgSrc: userStateData.getUserIconUrl() || '',
			postDate: 0,
			postMsg: 'This is an example fake post with an image',
			postImgSrc: 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg', // userStateData.getUserIconUrl(),
			verified: true
		}
		const fakePost3: UserPost = {
			postId: '6666',
			sourceName: 'Test User',
			community: 'Community Name',
			sourceImgSrc: 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg', // userStateData.getUserIconUrl() || '',
			postDate: 0,
			postMsg: 'Another fake post to test stacked posts in layout',
			postImgSrc: undefined,
			verified: true
		}
		setUserPosts([fakePost, fakePost2, fakePost3])
	}

	return (
		<>
			{firstSearchLoaded &&
				<>
					<div className='section-wrap'>
						<div className='section-content'>
							<HeaderAppExplore />
						</div>
					</div>
					<div className='app-explore-communities-reel-wrap'>
						{communityProfiles.map((profile: CommunitiesResultProfile, index: number) => 
							<div 
								className='app-explore-communities-reel-item'
								key={`commProfile${index}`}
								onClick={() => {
									window.location.replace(`${PAGE_URLS.APP_COMMUNITY}`)
								}}
							>
								<div className='app-explore-communities-reel-item-img'>
									<img 
										className='app-explore-communities-reel-item-img-inner'
										src={profile.profile_pic}
										alt='Profile'
									/>
								</div>
								<div className='app-explore-communities-reel-item-label'>{profile.name.length > 9 ? `${profile.name.substring(0, 9)}...` : profile.name}</div>
							</div>
						)}
						{/* <div className='app-explore-communities-reel-item'>
							<div className='app-explore-communities-reel-item-img'>
								<img 
									className='app-explore-communities-reel-item-img-inner'
									src={'/imgs/temp/community/temp-icon.png'}
									alt='Profile'
								/>
							</div>
							<div className='app-explore-communities-reel-item-label'>Community Name</div>
						</div>
						<div className='app-explore-communities-reel-item'>
							<div className='app-explore-communities-reel-item-img'>
								<img 
									className='app-explore-communities-reel-item-img-inner'
									src={'/imgs/temp/community/temp-icon.png'}
									alt='Profile'
								/>
							</div>
							<div className='app-explore-communities-reel-item-label'>Community Name</div>
						</div>
						<div className='app-explore-communities-reel-item'>
							<div className='app-explore-communities-reel-item-img'>
								<img 
									className='app-explore-communities-reel-item-img-inner'
									src={'/imgs/temp/community/temp-icon.png'}
									alt='Profile'
								/>
							</div>
							<div className='app-explore-communities-reel-item-label'>Community Name</div>
						</div>
						<div className='app-explore-communities-reel-item'>
							<div className='app-explore-communities-reel-item-img'>
								<img 
									className='app-explore-communities-reel-item-img-inner'
									src={'/imgs/temp/community/temp-icon.png'}
									alt='Profile'
								/>
							</div>
							<div className='app-explore-communities-reel-item-label'>Community Name</div>
						</div>
						<div className='app-explore-communities-reel-item'>
							<div className='app-explore-communities-reel-item-img'>
								<img 
									className='app-explore-communities-reel-item-img-inner'
									src={'/imgs/temp/community/temp-icon.png'}
									alt='Profile'
								/>
							</div>
							<div className='app-explore-communities-reel-item-label'>Community Name</div>
						</div>
						<div className='app-explore-communities-reel-item'>
							<div className='app-explore-communities-reel-item-img'>
								<img 
									className='app-explore-communities-reel-item-img-inner'
									src={'/imgs/temp/community/temp-icon.png'}
									alt='Profile'
								/>
							</div>
							<div className='app-explore-communities-reel-item-label'>Community Name</div>
						</div> */}
					</div>
					<div className='section-wrap section-seperator lcp-shift-min-height extra-footer-space'>
						<div className='app-explore-top-section-wrap'>
							<div className='app-community-page-switch-wrap'>
								<div 
									className={`app-community-page-switch-button ${showingExplore === true ? 'app-community-page-switch-button-selected' : ''}`}
									onClick={() => {
										setShowingExplore(true)
									}}
								>
									<div
										className='app-community-page-switch-label'
									>Explore</div>
								</div>
								{/* <div className='app-community-page-switch-button'> */}
								<div 
									className={`app-community-page-switch-button ${showingExplore === false ? 'app-community-page-switch-button-selected' : ''}`}
									onClick={() => {
										setShowingExplore(false)
									}}
								>
									<div
										className='app-community-page-switch-label'
									>My Feed</div>
								</div>
							</div>
						</div>
						<div className='app-community-page-content-section-wrap'>
							{showingExplore ? 
								<>
									{userPosts.length > 0 ?
										userPosts.map((postData: UserPost, index: number) => <AppUserPost data={postData} key={`post${index}`} />)
										:
										<div className='app-community-page-content-section-empty-text'>
											Loading
										</div>
									}
								</>
								:
								<div className='app-community-page-content-section-empty-text'>
									<div className='app-community-page-content-section-empty-text-title'>You haven't posted yet...</div>
									<div className='app-community-page-content-section-empty-text-sub-text'>Get started by going to communities<br/>and tapping the post button!</div>
								</div>
							}
						</div>
					</div>
					<BackToTopButton />
				</>
			}
			<AppPostButton />
			<AppFooter activeIndex={0} />
			{showNewPost && <AppPost />}
		</>
	)
}

export default AppExplore
